import { FormattedMessage } from 'react-intl'
import {VisibilityEventListToolbar} from './VisibilityEventListToolbar'

const VisibilityEventListHeader = () => {

  return (
    <div className='card-header border-0 pt-6'>
      <h2 className='fw-bolder'>{<FormattedMessage id ="VISIBILITY.EVENTS.LIST"/>}</h2>
      {/* <ParametersListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {<VisibilityEventListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {VisibilityEventListHeader}
